export const SET_ALERT_MODAL = "SET_ALERT_MODAL";
export const MODAL_TYPE = "MODAL_TYPE";
export const MODAL_TITLE = "MODAL_TITLE";
export const MODAL_DESCRIPTION = "MODAL_DESCRIPTION";
export const MODAL_BUTTON_URL = "MODAL_BUTTON_URL";
export const SET_ALERT_MULTIPLE = "SET_ALERT_MULTIPLE";

export default (state = { alertModal:false, modalType: '', modalTitle: '' , modalDescription: '' , modalButtonUrl: '' }, action: any)  => {
    switch (action.type) {
        case SET_ALERT_MODAL:
            const {alertModal} = action
            return {...state, alertModal};
        case MODAL_TYPE:
            const {modalType} = action
            return {...state, modalType};
        case MODAL_TITLE:
            const {modalTitle} = action
            return {...state, modalTitle};
        case MODAL_DESCRIPTION:
            const {modalDescription} = action
            return {...state, modalDescription};
        case MODAL_BUTTON_URL:
            const {modalButtonUrl} = action
            return {...state, modalButtonUrl};
        case SET_ALERT_MULTIPLE:
            return {...state, ...action.payload };
        default:
            return state
    }
};

export const setAlertModal = (alertModal: boolean, modalType: string, modalTitle: string, modalDescription: string, modalButtonUrl: string) => (
    {
        type: SET_ALERT_MODAL, MODAL_TYPE, MODAL_TITLE, MODAL_DESCRIPTION, MODAL_BUTTON_URL,
        alertModal, modalType, modalTitle, modalDescription, modalButtonUrl
    }
)
